import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { compose } from "redux";

import { removeTZFromDate, debounce, hydrateTestCallsFilter } from "utils";
import { useWindowWidth } from "hooks";
import FormHOC from "hoc/FilltersForm";
import m from "definedMessages";
import CustomSelfClearedForm from "components/client/Form/CustomSelfClearedForm";
import CustomField from "components/client/Form/CustomField/CustomField";
import DatePickerCustom from "components/Filters/DatePickerCustom";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";
import { BaseInputField } from "components/base/BaseForm";


const TestCallsFilters = (
    {
        loading,
        service,
        filtersModel,
        onChangeFilters,
        savedTableFilter,
        formatMessage
    }
) => {

    const resizedWidth = useWindowWidth();


    // let form;

    const todayDateStart = new Date(new Date().setHours(0, 0, 0, 0));
    const todayDateEnd = new Date(new Date().setHours(23, 59, 59, 999));

    const defaultFilter = {
        start_end_date: [todayDateStart, todayDateEnd],
        start_date: new Date(),
        end_date: new Date(),
        ...(service ? { a_number: "" } : { senderid: "" }),
        ...(service ? { b_number: "" } : { phone: "" })
    };

    const initialValue = hydrateTestCallsFilter(savedTableFilter, defaultFilter);
    const [changedFormValue, changeFormData] = useState(initialValue);

    useEffect(() => {
        changeFormData(hydrateTestCallsFilter(savedTableFilter, defaultFilter));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [service]);

    const onSubmit = (data, checkedData) => {
        const checker = Object.keys(checkedData).map(i => checkedData[i].hasError).every(value => value === false);

        if (checker) {
            onChangeFilters({
                ...data,
                start_date: removeTZFromDate(data.start_date),
                end_date: removeTZFromDate(data.end_date),
            });
        }

        return false;
    };

    return (
        <CustomSelfClearedForm
            // ref={ref => (form = ref)}
            clearOn={service}
            model={filtersModel}
            formDefaultValue={changedFormValue}
            onChange={debounce((data) => {
                const startDate = new Date(new Date(data.start_end_date[0]).setHours(0, 0, 0, 0));
                const endDate = new Date(new Date(data.start_end_date[1]).setHours(23, 59, 59, 999));
                const formData = { ...data, start_date: startDate, end_date: endDate };
                const checkedData = filtersModel.check(formData);
                onSubmit(formData, checkedData);
                changeFormData(formData);
            }, 1000)}
            fluid
            readOnly={loading}
        >

            <FlexGrid align="middle">

                {
                    (resizedWidth > 912) &&
                    <FlexGridItem>{formatMessage(m.fromDate)}</FlexGridItem>
                }
                <FlexGridItem width={resizedWidth > 767 ? "230px" : "100%"}>
                    <DatePickerCustom
                        isDisabledDates
                        changedFormValue={changedFormValue}
                        showRangeForSevenDays={false}
                    />
                </FlexGridItem>

                <FlexGridItem width={resizedWidth > 767 ? "230px" : "100%"}>
                    <CustomField
                        // formValue={changedFormValue?.senderid}
                        accepter={BaseInputField}
                        name={service ? "a_number" : "senderid"}
                        errorPlacement="topEnd"
                        placeholder={service ? formatMessage(m.aNumber) : formatMessage(m.senderId)}
                    />
                </FlexGridItem>

                <FlexGridItem width={resizedWidth > 767 ? "230px" : "100%"}>
                    <CustomField
                        accepter={BaseInputField}
                        name={service ? "b_number" : "phone"}
                        errorPlacement="topEnd"
                        placeholder={formatMessage(m.bNumber)}
                    />

                </FlexGridItem>
            </FlexGrid>
        </CustomSelfClearedForm>
    );
};

export default compose(
    FormHOC
)(TestCallsFilters)